export default "__VITE_ASSET__ade50829__"